/*
 * @Date         : 2021-07-30 15:49:19
 * @LastEditors: zhangxu
 * @LastEditTime: 2022-05-13 13:47:34
 * @FilePath: /daodao-biz-front/src/router/sidebar.ts
 */
/**
 * ! hidden 用以控制菜单隐藏权限.
 */
export const sidebarRoutes: any[] = [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: '概况总览',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'dashboard',
      visible: true,
      permissionId: [1100],
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/indexNew.vue'),
  },
  // 评估中心
  {
    path: '/evaluation-quick-launch',
    name: 'evaluation-quick-launch',
    meta: {
      title: '快速发起评估',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'evaluation-quick-launch',
      visible: true,
      permissionId: [1200],
    },
    component: () =>
      import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/evaluation-quick-launch.vue'),
  },

  {
    path: '/evaluation-diagnose-library',
    name: 'evaluation-diagnose-library',
    meta: {
      title: '评估测评列表',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'evaluation-diagnose-library',
      visible: true,
      permissionId: [1200],
    },
    component: () => import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/diagnose-library.vue'),
  },
  {
    path: '/evaluation-diagnose-initiation-record',
    name: 'evaluation-diagnose-initiation-record',
    meta: {
      title: '评估活动追踪',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'evaluation-diagnose-initiation-record',
      visible: true,
      permissionId: [1200],
    },
    component: () =>
      import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/diagnose-initiation-record.vue'),
  },
  {
    path: '/evaluation-diagnose-report-record',
    name: 'evaluation-diagnose-report-record',
    meta: {
      title: '评估报告记录',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'evaluation-diagnose-report-record',
      visible: true,
      permissionId: [1700],
    },
    component: () =>
      import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/diagnose-report-record.vue'),
  },
  // 档案公海
  {
    path: '/open-seas',
    name: 'open-seas',
    meta: {
      title: '档案公海',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'open-seas',
      visible: true,
      permissionId: [1400],
    },
    component: () => import(/* webpackChunkName: "growthCenter" */ '@/views/growth-center/open-seas/archives-list.vue'),
  },
  // 成长中心
  {
    path: '/archives',
    name: 'archives',
    meta: {
      title: '成长档案',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'archives',
      visible: true,
      permissionId: [1400],
    },
    component: () => import(/* webpackChunkName: "growthCenter" */ '@/views/growth-center/growth-archives/index.vue'),
  },
  // 评估工具库
  {
    path: '/diagnose-library',
    name: 'diagnose-library',
    meta: {
      title: '评估工具库',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'diagnose-library',
      visible: true,
      permissionId: [1700],
      yellowTips: 1, // 小黄条类型
    },
    component: () => import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/diagnose-library.vue'),
  },
  {
    path: '/diagnose-initiation-record',
    name: 'diagnose-initiation-record',
    meta: {
      title: '评估活动追踪',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'diagnose-initiation-record',
      visible: true,
      permissionId: [1700],
    },
    component: () =>
      import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/diagnose-initiation-record.vue'),
  },
  {
    path: '/diagnose-report-record',
    name: 'diagnose-report-record',
    meta: {
      title: '评估报告记录',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'diagnose-report-record',
      visible: true,
      permissionId: [1700],
    },
    component: () =>
      import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/diagnose-report-record.vue'),
  },
  {
    path: '/gen-receive-code',
    name: 'gen-receive-code',
    meta: {
      title: '生成激活码',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'gen-receive-code',
      visible: true,
      permissionId: [1700],
    },
    component: () => import(/* webpackChunkName: "gen-receive-code" */ '@/views/diagnose-center/gen-receive-code.vue'),
  },
  {
    path: '/growUpData',
    name: 'growUpData',
    meta: {
      title: '成长方案库',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'growUpData',
      visible: true,
      permissionId: [1900],
    },
    component: () => import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/growUpData.vue'),
  },
  {
    path: '/channelPromotion',
    name: 'channelPromotion',
    meta: {
      title: '业绩总览',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'channelPromotion',
      visible: true,
      permissionId: [3000],
    },
    component: () => import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/channelPromotion.vue'),
  },
  {
    path: '/customerManagement',
    name: 'customerManagement',
    meta: {
      title: '客户管理',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'customerManagement',
      visible: true,
      permissionId: [3000],
    },
    component: () => import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/customerManagement.vue'),
  },
  // 方案中心
  {
    path: '/programme-library',
    name: 'programme-library',
    meta: {
      title: '评估报告记录',
      keepAlive: true,
      requireAuth: true,
      routerKey: 'programme-library',
      visible: true,
      permissionId: [1700],
    },
    component: () => import(/* webpackChunkName: "programme-center" */ '@/views/programme-center/programmeLibrary.vue'),
  },
  {
    path: '/programme-create',
    name: 'programme-create',
    meta: {
      title: '评估报告记录',
      keepAlive: true,
      requireAuth: true,
      routerKey: 'programme-create',
      visible: true,
      permissionId: [1700],
    },
    component: () => import(/* webpackChunkName: "programme-center" */ '@/views/programme-center/programmeCreate.vue'),
  },
  // 升学规划

  {
    path: '/further-enroll',
    name: 'further-enroll',
    meta: {
      title: '升学填报',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'service',
      ignoreCrumbs: true,
    },
    component: () => import(/* webpackChunkName: "further" */ '@/views/further/workbench/index.vue'),
  },
  {
    path: '/customers',
    name: 'customers',
    meta: {
      title: '升学获客',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'customers',
      visible: true,
      permissionId: [2100],
    },
    component: () => import(/* webpackChunkName: "further" */ '@/views/further/customers/index.vue'),
  },
  {
    path: '/service',
    name: 'service',
    meta: {
      title: '1v1填报',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'service',
      visible: true,
      permissionId: [2200],
      yellowTips: 2, // 小黄条类型
    },
    component: () => import(/* webpackChunkName: "further" */ '@/views/further/service/index.vue'),
  },
  {
    path: '/cards',
    name: 'cards',
    meta: {
      title: '发行志愿卡',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'cards',
      visible: true,
      permissionId: [2300],
    },
    component: () => import(/* webpackChunkName: "further" */ '@/views/further/cards/index.vue'),
  },
  // 辅助工具
  {
    path: '/university-library',
    name: 'university-library',
    meta: {
      title: '院校查询',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'university-library',
      visible: true,
      permissionId: [1700],
    },
    component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/universityLibrary.vue'),
  },
  {
    path: '/university-rank',
    name: 'university-rank',
    meta: {
      title: '院校排行榜',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'university-rank',
      visible: true,
      permissionId: [1700],
    },
    component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/universityRank.vue'),
  },
  {
    path: '/major-library',
    name: 'major-library',
    meta: {
      title: '专业查询',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'major-library',
      visible: true,
      permissionId: [1700],
    },
    component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/majorLibrary.vue'),
  },
  {
    path: '/occupation-library',
    name: 'occupation-library',
    meta: {
      title: '就业前景',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'occupation-library',
      visible: true,
      permissionId: [1700],
    },
    component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/occupationLibrary.vue'),
  },
  {
    path: '/pre-batch',
    name: 'pre-batch',
    meta: {
      title: '提前批',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'pre-batch',
      visible: true,
      permissionId: [1700],
    },
    component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/preBatch.vue'),
  },
  {
    path: '/batch-score',
    name: 'batch-score',
    meta: {
      title: '批次线',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'batch-score',
      visible: true,
      permissionId: [1700],
    },
    component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/batchLine.vue'),
  },
  {
    path: '/rank-line',
    name: 'rank-line',
    meta: {
      title: '位次查询',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'rank-line',
      visible: true,
      permissionId: [1700],
    },
    component: () => import(/* webpackChunkName: "tools" */ '@/views/tools/rankScore.vue'),
  },
  // 人才评估
  {
    path: '/assess',
    name: 'assess',
    meta: {
      title: '人才评估',
      keepAlive: true,
      requireAuth: true,
      routerKey: 'assess',
      visible: true,
      permissionId: [3100],
    },
    component: () => import(/* webpackChunkName: "assess" */ '@/views/assess/index.vue'),
  },
  {
    path: '/setting/account-setting',
    name: 'account-setting',
    meta: {
      title: '账号与权限',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'account-setting',
      visible: true,
      permissionId: [10000],
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/index.vue'),
  },
  {
    path: '/setting/bill',
    name: 'bill',
    meta: {
      title: '余额与账单',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'bill',
      visible: true,
      permissionId: [10010],
      yellowTips: 3, // 小黄条类型
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/Bill.vue'),
  },
  {
    path: '/setting/custom-setting',
    name: 'custom-setting',
    meta: {
      title: '自定义设置',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'custom-setting',
      visible: true,
      permissionId: [10000],
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/CustomSetting.vue'),
  },
  {
    name: 'app-react/selectsubject',
    path: '/app-react/selectsubject',
    meta: {
      isMicrApp: true,
      keepAlive: false,
      visible: true,
      title: '新高考选科',
    },
    component: () => import(/* webpackChunkName: "layout" */ '@/views/widget/MicroBlank.vue'),
  },
]
